import { createSlice } from "@reduxjs/toolkit";
import { getInfoUser } from "../../api/User/infoUser";

const initialState = {
  user: null,
  loadUser: false,
  allUser: null,
};

const user = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInfoUser.pending, (state) => {
        state.loadUser = true;
      })
      .addCase(getInfoUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loadUser = false;
      })
      .addCase(getInfoUser.rejected, (state, action) => {
        state.loadUser = false;
        // state.eroi = action.error.message;
      });
  },
});

// export const {} = user.actions

export default user.reducer;
